import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { PayloadUploadExamsPatient } from '../../models/requests'
import { Callbacks } from '../../models/callbacks'
import { environment } from '../../../environments/environment'
import { finalize } from 'rxjs/operators'

@Injectable({
	providedIn: 'root',
})
export class PatientUploadExamsService {
	constructor(private http: HttpClient) {}

	uploadExamsPatient(body: PayloadUploadExamsPatient, callbacks: Callbacks) {
		const { file, appointmentId, patientId } = body

		const formData = new FormData()
		formData.append('file', file)
		formData.append('exam_value', file.name || 'Arquivo')
		formData.append('appointment_id', appointmentId)
		formData.append('patient_id', patientId)

		this.http
			.post(`${environment.api}/patient-exams`, formData)
			.pipe(
				finalize(() => {
					if (callbacks.fnFinalized) callbacks.fnFinalized()
				})
			)
			.subscribe(
				(data) => {
					callbacks.fnSuccess(data)
				},
				(error) => {
					callbacks.fnError(error)
				}
			)
	}
}
